<div
   class="hd-shell"
   *ngIf="!loading">
   <div class="hd-stat-row">
      <div class="hd-stat-card hd-dvm">
         <div class="hd-stat-label">Associate DVMs (Q3)</div>
         <div class="hd-stat-pct">{{ dvmStats.completePct }}%</div>
         <div class="hd-stat-sub">{{ dvmStats.completed }} of {{ dvmStats.total }} complete</div>
         <div class="hd-stat-track">
            <div
               class="hd-stat-fill"
               [style.width.%]="dvmStats.completePct"
               style="background: #14a19a"></div>
         </div>
         <span
            class="hd-stat-badge"
            [class.hd-badge-open]="isCycleOpen('DVM')"
            [class.hd-badge-closed]="!isCycleOpen('DVM')">
            {{ isCycleOpen("DVM") ? "Active" : "Closed" }}
         </span>
      </div>

      <div class="hd-stat-card hd-hm">
         <div class="hd-stat-label">Hospital Managers</div>
         <div class="hd-stat-pct">{{ hmStats.completePct }}%</div>
         <div class="hd-stat-sub">{{ hmStats.completed }} of {{ hmStats.total }} complete</div>
         <div class="hd-stat-track">
            <div
               class="hd-stat-fill"
               [style.width.%]="hmStats.completePct"
               style="background: #0374b6"></div>
         </div>
         <span
            class="hd-stat-badge"
            [class.hd-badge-open]="isCycleOpen('HM')"
            [class.hd-badge-closed]="!isCycleOpen('HM')">
            {{ isCycleOpen("HM") ? "Active" : "Closed" }}
         </span>
      </div>

      <div class="hd-stat-card hd-cos">
         <div class="hd-stat-label">Chiefs of Staff</div>
         <div class="hd-stat-pct">{{ cosStats.completePct }}%</div>
         <div class="hd-stat-sub">{{ cosStats.completed }} of {{ cosStats.total }} complete</div>
         <div class="hd-stat-track">
            <div
               class="hd-stat-fill"
               [style.width.%]="cosStats.completePct"
               style="background: #831183"></div>
         </div>
         <span
            class="hd-stat-badge"
            [class.hd-badge-open]="isCycleOpen('COS')"
            [class.hd-badge-closed]="!isCycleOpen('COS')">
            {{ isCycleOpen("COS") ? "Active" : "Closed" }}
         </span>
      </div>

      <div class="hd-stat-card hd-rm">
         <div class="hd-stat-label">Regional Managers</div>
         <div class="hd-stat-pct">{{ rmStats.completePct }}%</div>
         <div class="hd-stat-sub">{{ rmStats.completed }} of {{ rmStats.total }} complete</div>
         <div class="hd-stat-track">
            <div
               class="hd-stat-fill"
               [style.width.%]="rmStats.completePct"
               style="background: #fdb815"></div>
         </div>
         <span
            class="hd-stat-badge"
            [class.hd-badge-open]="isCycleOpen('RM')"
            [class.hd-badge-closed]="!isCycleOpen('RM')">
            {{ isCycleOpen("RM") ? "Active" : "Closed" }}
         </span>
      </div>

      <div class="hd-stat-card hd-do">
         <div class="hd-stat-label">Directors of Operations</div>
         <div class="hd-stat-pct">{{ doStats.completePct }}%</div>
         <div class="hd-stat-sub">{{ doStats.completed }} of {{ doStats.total }} complete</div>
         <div class="hd-stat-track">
            <div
               class="hd-stat-fill"
               [style.width.%]="doStats.completePct"
               style="background: #ee5d20"></div>
         </div>
         <span
            class="hd-stat-badge"
            [class.hd-badge-open]="isCycleOpen('DO')"
            [class.hd-badge-closed]="!isCycleOpen('DO')">
            {{ isCycleOpen("DO") ? "Active" : "Closed" }}
         </span>
      </div>

      <div class="hd-stat-card hd-team">
         <div class="hd-stat-label">Team Members</div>
         <div class="hd-stat-pct">{{ teamStats.completePct }}%</div>
         <div class="hd-stat-sub">{{ teamStats.completed }} of {{ teamStats.total }} complete</div>
         <div class="hd-stat-track">
            <div
               class="hd-stat-fill"
               [style.width.%]="teamStats.completePct"
               style="background: #ee5d20"></div>
         </div>
         <span
            class="hd-stat-badge"
            [class.hd-badge-open]="isCycleOpen('CROSSTRAINED')"
            [class.hd-badge-closed]="!isCycleOpen('CROSSTRAINED')">
            {{ isCycleOpen("CROSSTRAINED") ? "Active" : "Closed" }}
         </span>
      </div>
   </div>

   <div class="hd-main-grid">
      <div class="hd-left">
         <div class="hd-panel-header">
            <div class="hd-section-title">Submission Progress by Review Type</div>

            <div class="hd-legend">
               <div class="hd-legend-item">
                  <span
                     class="hd-legend-dot"
                     style="background: #03af9c"></span>
                  Reviewee Submitted
               </div>
               <div class="hd-legend-item">
                  <span
                     class="hd-legend-dot"
                     style="background: #0374b6"></span>
                  Reviewer Submitted
               </div>
            </div>
         </div>

         <div class="hd-review-list">
            <div
               class="hd-review-card"
               *ngFor="let rt of reviewTypeRows">
               <div class="hd-review-header">
                  <div class="hd-review-name">
                     <i
                        [class]="'fa ' + rt.icon"
                        aria-hidden="true"
                        style="font-size: 15px; color: var(--muted)"></i>
                     {{ rt.label }}
                  </div>
                  <div class="hd-review-meta">
                     <span class="hd-review-count">{{ rt.cycleLabel ? rt.cycleLabel + " · " : "" }}{{ rt.stats.total }} reviews</span>
                     <span
                        class="hd-badge"
                        [class.hd-badge-open]="rt.open"
                        [class.hd-badge-closed]="!rt.open">
                        {{ rt.open ? "Active" : "Closed" }}
                     </span>
                  </div>
               </div>
               <div class="hd-bar-rows">
                  <div class="hd-bar-row">
                     <span class="hd-bar-lbl">Reviewee</span>
                     <div class="hd-bar-track">
                        <div
                           class="hd-bar-fill hd-fill-ee"
                           [style.width.%]="rt.stats.revieweePct"></div>
                     </div>
                     <span class="hd-bar-pct">{{ rt.stats.revieweePct }}%</span>
                  </div>
                  <div class="hd-bar-row">
                     <span class="hd-bar-lbl">{{ rt.reviewerLabel }}</span>
                     <div class="hd-bar-track">
                        <div
                           class="hd-bar-fill hd-fill-er"
                           [style.width.%]="rt.stats.reviewerPct"></div>
                     </div>
                     <span class="hd-bar-pct">{{ rt.stats.reviewerPct }}%</span>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="hd-right">
         <div class="hd-panel-header">
            <span class="hd-panel-title">Deferral Requests</span>
            <span
               class="hd-view-all"
               (click)="goToDeferrals()">
               View all →
            </span>
         </div>

         <div class="hd-panel">
            <div class="hd-defer-tiles">
               <div class="hd-defer-tile">
                  <div class="hd-defer-val">{{ pendingCount }}</div>
                  <div class="hd-defer-tile-label">Pending review</div>
               </div>
               <div class="hd-defer-tile">
                  <div class="hd-defer-val hd-defer-pending">{{ totalDeferred }}</div>
                  <div class="hd-defer-tile-label">Total deferred</div>
               </div>

               <div class="hd-defer-tile">
                  <div class="hd-defer-val hd-defer-reenabled">{{ reEnabledCount }}</div>
                  <div class="hd-defer-tile-label">Re-enabled</div>
               </div>
            </div>

            <div class="hd-pending-header">
               <span class="hd-pending-header-label">Pending requests</span>
               <span
                  class="hd-pending-badge"
                  *ngIf="pendingCount > 0">
                  {{ pendingCount }}
               </span>
            </div>

            <div
               *ngIf="pendingRequests.length === 0"
               class="hd-empty">
               No pending deferral requests.
            </div>

            <div
               class="hd-pending-item"
               *ngFor="let req of pendingRequests">
               <div
                  class="hd-av"
                  [style.background]="getAvatarBg(req.revieweeName)"
                  [style.color]="getAvatarColor(req.revieweeName)">
                  {{ getInitials(req.revieweeName) }}
               </div>
               <div class="hd-pending-info">
                  <div class="hd-pending-name">{{ req.revieweeName }}</div>
                  <div class="hd-pending-reason">{{ req.reason }}</div>
                  <div class="hd-pending-meta">
                     <span class="hd-cycle-chip">{{ req.role }}</span>
                     <span class="hd-pending-date">{{ req.requestedOn | date: "MMM d, yyyy" }}</span>
                  </div>
               </div>
               <span
                  class="hd-goto-btn"
                  (click)="goToDeferrals()">
                  Review →
               </span>
            </div>
         </div>
      </div>
   </div>
</div>

<div
   class="hd-loading"
   *ngIf="loading">
   <span
      class="spinnerSave"
      style="display: block; margin: 40px auto"></span>
</div>
